module.exports = global["_"] = require("-!./underscore-1.8.2.js");